/**
 * Server-reported availability of the Preslink create-data and render routes.
 *
 * The BFF only configures those routes when the service base URL is a
 * Finster-hosted HTTPS URL or a private-network address (see
 * `apps/server/config.js`). This is a capability report, not a rollout
 * percentage: the add-in must not offer chart creation when the server cannot
 * reach the service.
 *
 * Held at module scope rather than threaded through props because the routing
 * gate is read deep inside the query handler, far from the auth state. It is
 * fail-closed: unset means unavailable.
 */
let configured = false;

/** Called from the auth layer whenever a session is loaded, refreshed, or cleared. */
export function setPreslinkCreateDataConfigured(value: boolean | undefined): void {
  configured = value === true;
}

export function isPreslinkCreateDataConfigured(): boolean {
  return configured;
}
